
import clientAuth from "../clientAuth"
export default {
    index: (userData) => clientAuth.post(`orders/index`,{json:userData}),

    destroy: (order_id) => clientAuth.delete(`orders/destroy/${order_id}`),
    // store: (order_id) => clientAuth.delete(`orders/ordercancle`),
    cancle: (userData) => clientAuth.post('orders/ordercancle', { json: userData }),

    refund: (userData) => clientAuth.post('orders/orderrefund', { json: userData }),
    updatepaidstatus: (userData) => clientAuth.post('orders/updatepaidstatus', { json: userData }),
    updatechecktatus: (userData) => clientAuth.post('orders/updatechecktatus', { json: userData }),
    updatecomments: (order_id, slug, userData) => clientAuth.post(`orders/updatecomments/${order_id}/${slug}`, { json: userData }),
    Orderdestroy: (id) => clientAuth.delete(`orders/destroy/${id}`),
    resendBooking: (bookingid) => clientAuth.post(`orders/resend-booking-email/${bookingid}`),
    updatereview: (orderid) => clientAuth.post(`orders/updatereview/${orderid}`),
    getdocument: (id) => clientAuth.get(`orders/user/document/${id}`),
    documentstore: (userData) => clientAuth.post('orders/user/document/store', { json: userData }),
    getdocumentbyid: (id) => clientAuth.get(`orders/user/document/show/${id}`),
    updatedocument: (userData) => clientAuth.post(`orders/user/document/update`, { json: userData }),

    updateOrderstatus: (id) => clientAuth.post(`notification/orderdetail/update/${id}`),
    // yearfilter:
    updatesatisfied: (orderid, payload) => clientAuth.post(`orders/bookings/is-satisfied/${orderid}`, {json: payload}),
    updateReviewReminder: (orderid, payload) => clientAuth.post(`orders/bookings/review-reminder-2/${orderid}`, {json: payload}),
    updateReviewSubmitted: (orderid, payload) => clientAuth.post(`orders/bookings/review-submitted/${orderid}`, {json: payload}),
    updateDepositRefunded: (orderid, payload) => clientAuth.post(`orders/bookings/deposit-refunded/${orderid}`, {json: payload}),

    indextodaypickupreturn: (userData) => clientAuth.post(`staff/slot/pickup-return/currentday`,{json:userData}),

    updatePrepare: (orderid) => clientAuth.post(`staff/slot/pickup-return/prepared/${orderid}`),
    filterDate: (filterData) => clientAuth.post(`staff/slot/pickup-return/currentday`, {json:filterData}),
    updateKautionempfangen: (orderid) => clientAuth.post(`staff/slot/pickup-return/deposit_received/${orderid}`),


};

// Manage Booking link api (post method) : {{url}}/admin/orders/index
// {
//     // "year":2025,
//     // "start_date":"2024-03-23",
//     // "end_date":"2024-08-01"
//     // "email":"susanne-krapp@gmx.de"
//     "payment_status":3
// }